import Axios from "axios"

export default {

  /**
   * 参数
   */
  params() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/login_wework/login_param`);
  },

  /**
   * 验证
   * @param {*} code 
   * @param {*} state 
   * @param {*} appid 
   */
  check(
    code,
    state,
    appid
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/login_wework/check`, {
      params: {
        code,
        state,
        appid
      }
    });
  }

}